'use client';

import { useTranslations } from 'next-intl';
import { useAuthenticatedContext } from '@/app/components/Provider';
import { Link } from '@/i18n/routing';
import appConst from '~/const/appConst';
import { isAuthenticatedAsMainUser } from '~/utils/user/user';

export function FooterHelp() {
  const t = useTranslations('NAVIGATION');
  const { user, isAuthenticated } = useAuthenticatedContext();

  return isAuthenticatedAsMainUser(user, isAuthenticated)
    ? (
        <section>
          <p className="vp-body-s footer__title">{t('HELP')}</p>
          <nav aria-label={t('HELP')} role="navigation">
            <ul>
              <li>
                <Link
                  className="vp-link vp-link--on-brand"
                  href={appConst.staticRoutes.contact}
                  rel="noindex, nofollow"
                  prefetch={false}
                >
                  <span className="vp-link__label" data-part="label">
                    {t('CONTACT')}
                  </span>
                </Link>
              </li>
            </ul>
          </nav>
        </section>
      )
    : null;
}
